module.exports = __webpack_public_path__ + "img/75737.b850ee9c.svg";